import { FaqStructureType_faqCollection_items } from "globalQueries/contentfulTypes/FaqStructureType";
import { UrlStructureItem } from "types/UrlStructureItem";

export const FaqStructureUrlFactory = (
  array: Array<FaqStructureType_faqCollection_items>,
): UrlStructureItem[] => {
  const flatStructure: UrlStructureItem[] = [];
  const urls = getFactsFlatUrlStructure(array, flatStructure);

  return urls;
};

const getFactsFlatUrlStructure = (
  array: Array<FaqStructureType_faqCollection_items>,
  flatStructure: UrlStructureItem[],
): UrlStructureItem[] => {
  array?.forEach((item) => {
    if (item?.slug)
      flatStructure.push({
        slug: item?.slug,
        url: "/kundtjanst/fragor-och-svar/" + item?.slug,
        name: item?.question,
      });
  });
  return flatStructure;
};
